import useGa from 'Client/hooks/useGa';
import { useLogger } from 'Client/logger/LoggerProvider';
import { FeatureToggles } from 'Common/appshell_types';
import {
    CommonEventOptions,
    DataLayerItem,
    MFEventOptions,
    TrackPageViewArguments,
    TrackingHelpers,
} from 'Common/appshell_types/trackingHelpers';

const useTrackingHelpers = (mfName: string) => {
    const ga = useGa();
    const logger = useLogger();

    const trackingHelpers: TrackingHelpers = {
        ga: {
            trackPageView: ({ pageType, gaData }: TrackPageViewArguments) => {
                ga.trackPageView({ pageType, gaData });
            },
            trackGenericEvent: (category: string, options: CommonEventOptions) => {
                ga.trackGenericEvent(category, options);
            },
            /**
             * Not every Ga event include category, action, label, event
             * Some events include SKU, or maybe nothing,
             */
            trackEvent: (eventName: string, options: MFEventOptions) => {
                ga.trackEvent(eventName, options);
            },
            pushToDatalayer: (options: DataLayerItem) => {
                // We add mf-name to each event so we know which MF sent this
                // without this we would never know who is sending what.
                const event = {
                    ...options,
                    mfName,
                };
                ga.pushToDatalayer(event);
            },
            trackVariation: (action: keyof FeatureToggles | string, label: string | boolean | undefined) => {
                ga.trackVariation(action, label);
            },
        },
        launchDarkly: {
            trackMetric: () => {
                logger.warn('launchDarkly.trackMetric is depricated');
            },
            trackImportantMetric: () => {
                logger.warn('launchDarkly.trackImportantMetric is depricated');
            },
            trackVariation: (action: keyof FeatureToggles | string, label: string | boolean | undefined) => {
                logger.warn('launchDarkly.trackVariation is depricated');
                ga.trackVariation(action, label);
            },
        },
    };

    return trackingHelpers;
};

export default useTrackingHelpers;
